module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tasks-list"
  }, [(_vm.isDesktop && _vm.isAdmin && _vm.currentCompany) ? _c('div', {
    staticClass: "tasks-list-admin-header"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'edit-company',
        params: {
          id: _vm.company
        }
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n            44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n            24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })]), _vm._v("\n      Back to \"" + _vm._s(_vm.currentCompany.label) + "\"\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-element tasks-list-admin-header-companies"
  }, [_c('label', {
    attrs: {
      "for": "companiesList"
    }
  }, [_vm._v("Change company")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select tasks-list-header-boards-selector",
    attrs: {
      "options": _vm.companies,
      "searchable": true,
      "clearable": false,
      "value": this.currentCompany,
      "name": "companiesList",
      "id": "companiesList"
    },
    on: {
      "change": function($event) {
        return _vm.changeCompany($event)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isDesktop) ? _c('div', {
    staticClass: "task-header tasks-list-header",
    class: {
      'search-opened': _vm.activeSearch, 'filters-opened': _vm.activeFilters
    },
    attrs: {
      "id": "taskHeader"
    }
  }, [_c('div', {
    staticClass: "tasks-list-header-buttons"
  }, [_c('div', [(_vm.isAdmin) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'edit-company',
        params: {
          id: _vm.company
        }
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n            44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n            24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })])]) : _c('router-link', {
    attrs: {
      "to": {
        name: _vm.userDashboard
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-arrow-left fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4\n            44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24\n            24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    }
  })])]), _vm._v(" "), _c('app-select', {
    staticClass: "tasks-list-header-boards-selector",
    attrs: {
      "options": _vm.taskBoardList,
      "searchable": false,
      "customActive": false,
      "clearable": false,
      "value": this.activeTab,
      "data-vv-name": "Task boards",
      "data-lpignore": "true",
      "name": "taskBoards",
      "id": "taskBoards"
    },
    on: {
      "change": function($event) {
        return _vm.changeTaskBoard($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "tasks-list-header-buttons-search-button",
    class: {
      active: _vm.activeSearch
    },
    on: {
      "click": function($event) {
        return _vm.activateSearch()
      }
    }
  }, [(_vm.activeSearch) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                  0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                  12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                  0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-search fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "search",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9\n                  0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4\n                  33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2\n                  128 128 0 70.7-57.2 128-128 128z"
    }
  })])]], 2), _vm._v(" "), _c('button', {
    staticClass: "tasks-list-header-buttons-filters-button",
    class: {
      active: _vm.activeFilters
    },
    on: {
      "click": function($event) {
        return _vm.activateFilters()
      }
    }
  }, [(_vm.activeFilters) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                  0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                  12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                  0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])] : [(_vm.allActiveFiltersCount) ? _c('span', {
    staticClass: "tasks-list-header-buttons-filters-button-count"
  }, [_vm._v(_vm._s(_vm.allActiveFiltersCount))]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "svg-inline--fa fa-filter fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "filter",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17\n                  10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    }
  })])]], 2)])]), _vm._v(" "), (_vm.activeSearch || _vm.activeFilters) ? _c('div', {
    staticClass: "tasks-list-header-container"
  }, [_c('tasks-device-filters', {
    attrs: {
      "company": _vm.company,
      "only-search": _vm.activeSearch,
      "list": _vm.activeTab.value
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('tabs', [_c('tab', {
    attrs: {
      "name": "Current focus",
      "alias": "focus"
    }
  }, [(_vm.isDesktop) ? _c('tasks-filters', {
    attrs: {
      "company": _vm.company,
      "list": "focus"
    }
  }) : _vm._e(), _vm._v(" "), _c('focus-tasks', {
    attrs: {
      "company": _vm.company
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Backlog",
      "alias": "backlog",
      "selected": true
    }
  }, [(_vm.isDesktop) ? _c('tasks-filters', {
    attrs: {
      "company": _vm.company,
      "list": "backlog"
    }
  }) : _vm._e(), _vm._v(" "), _c('backlog-tasks', {
    attrs: {
      "company": _vm.company
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-256de714","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tasks/TasksList.vue
// module id = 957
// module chunks = 0